const toggleElAttr = 'data-collapse';
const closeElAttr = 'data-collapse-close';

$('body').on('click', `[${toggleElAttr}]`, (e) => {
    e.preventDefault();

    $(e.currentTarget).toggleClass('open');
    $('#' + $(e.currentTarget).attr(toggleElAttr)).slideToggle();
});

$('body').on('click', `[${closeElAttr}]`, (e) => {
    e.preventDefault();

    $('#' + $(e.currentTarget).attr(closeElAttr)).slideUp();
});
